<template>
<div>
    <div class="card-title wise-card-title" style="padding-bottom:10px;">
      <span>공지사항</span>
      <span class="float-right">
        <input style="margin-left:5px;" v-model="filter" class="form-control" placeholder="검색" type="text"></input>
      </span>
    </div>
    <b-table id='noticeTable' :hover="hover" responsive="sm"  :filter="filter"
    :items="noticeItems" :fields="noticeFields" :current-page="currentPage" :per-page="perPage" thead-class="hidden_header" @row-clicked="contentClick">
    </b-table>
    <nav>
      <b-pagination :total-rows="getRowCount(noticeItems)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
    </nav>
    <b-modal  :title="title" size="lg" class="modal-primary" v-model="largeModal" @ok="largeModal = false">
      <div  class="modal-body">
        <div id="noticeModal" ></div>
      </div>
      <div slot="modal-footer" class="w-100">
        <b-btn size="md" class="float-right" variant="primary" @click="largeModal=false">
          닫기
        </b-btn>
      </div>
      <!-- {{content.content}} -->
      <!-- <iframe width="560" height="315" src="https://www.youtube.com/embed/A6Fcv8yHDNU" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
    </b-modal>
</div>
</template>

<script>
export default {
  name: 'c-table',
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    largeModal: false,
    content : {
      title:'',
      registered:''
    },
    title : '',
    filter : null
  },
  watch:{
    'largeModal': function() {
      if(this.largeModal == false){
        var elem = document.getElementById('noticeModal');
        elem.innerHTML = null;
      }
    },
  },
  data: () => {
    return {
      noticeItems: [
        {title: '닐슨싱글소스 3Screen RAW 데이터 요약 (패널상세 정보)', registered: '2018/11/27',
          type:'img',
          content: [
            '<img class="helpImg" src="static/img/contents/notice_content_1.png" height="100%" width="100%">',
            '<img class="helpImg" src="static/img/contents/notice_content_2.png" height="100%" width="100%">'
          ]
        },
        {title: '2018 DMIX 교육용 동영상, 효과측정 솔루션', registered: '2018/10/17',
          type:'movie',
          content: '<iframe width="560" height="315" src="https://www.youtube.com/embed/A6Fcv8yHDNU" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
        },
      ],
      noticeFields: [
        {key: 'title'},
        {key: 'registered'},
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0
    }
  },
  methods: {
    getRowCount (items) {
      return items.length
    },
    contentClick(record, index){
      // noticeModal
      var elem = document.getElementById('noticeModal');
      if(record.type == 'movie'){
        // var temp = elem.createElement('div');
        elem.innerHTML = null;
        elem.innerHTML = record.content;
        this.largeModal = true;
      }else if(record.type == 'img'){
        elem.innerHTML = null;
        for(var i=0; i<record.content.length; i++){
          elem.insertAdjacentHTML('beforeend', record.content[i]);
        }
        this.largeModal = true;
      }else{
        elem.innerHTML = null;
        this.content = record;
      }

      this.title = record.title;
      this.largeModal = true;
    }
  }
}
</script>
<style>
#noticeTable .hidden_header {
  display: none;
}
</style>
<style scoped>
.modal-body{
    max-height: 700px;
    overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Notice.vue